import React from 'react';
import type { InputProps } from 'antd/lib/input';

import MaskInput from '../MaskInput';

/**
 * Маска ПТС
 */
export default (props: InputProps) => (
  <MaskInput
    mask="***************"
    placeholder="_______________"
    showMask={false}
    formatChars={{
      '*': `[0-9]`,
    }}
    {...props}
  />
);
